jQuery(function($) {
  var accordionToggles = document.querySelectorAll('.accordion__toggle, .accordion__toggle--alt');
  for (var i = 0, len = accordionToggles.length; i < len; i++) {
    var accordionToggle = accordionToggles[i];
    accordionToggle.addEventListener('click', function(e) {
      this.parentNode.classList.toggle('accordion__item--active');
      e.preventDefault();
      $('.accordion__toggle__icon', this).toggleClass('is-toggled');
    });
  }
});